export const BREAKPOINTS = {
  xs: 480,
  sm: 650,
  md: 800,
  lg: 1034,
  xl: 1250,
  xxl: 1350,
  xxxl: 1500,
};
